import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage/storage.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private user: UserDetails = null;
  private userPromise = new BehaviorSubject<UserDetails>(this.user);
  public $user = this.userPromise.asObservable();
  public endPointUrl = environment.baseApiUrl;

  constructor(
    public router: Router,
    public storageService: StorageService,
    protected http: HttpClient
  ) {
    this.updateUser(this.storageService.getItem('user'));
  }

  public updateUser(userDetails: UserDetails) {
    this.storageService.setItem('userDetails', userDetails);
  }

  public token() {
    return this.storageService.getItem('token');
  }

  public checkAuth(state: RouterStateSnapshot) {
    return true;
  }

  public loginRedirect() {
    this.router.navigateByUrl('user/documents/document-grid');
  }

  public firstLoginRedirect() {
    this.router.navigateByUrl('user/profile/change-password/first-login');
  } 
  register(body: any) {
    return this.http.post(this.endPointUrl + "user/v1/register", body);

  }
  public logoutRedirect() {
    this.router.navigateByUrl('/login');
  }

  public passwordResetConfirm() {
    this.router.navigateByUrl('/passwordConfirm');
  }

  public logout() {
    const keepSignIn = this.storageService.getItem('keepSignIn');
    let email = this.storageService.getItem('email');
    localStorage.clear();
    this.storageService.setItem('email', email);
    this.storageService.setItem('keepSignIn', keepSignIn);
    this.user = null;
    this.logoutRedirect();
  }

  public login(body: any) {
    return this.http.post(this.endPointUrl + "user/v1/custom/api/token", body, { observe: 'response' })
  }


  public getProfileDetails() {
     const token = localStorage.getItem('token');
 
    if (!token) {
      console.warn('Authorization token missing. Skipping profile fetch.');
      return EMPTY;
    }
    return this.http.get(this.endPointUrl + "user/v1/profile")
  }

  public updaeProfileDetails(id,body:{}) {
    return this.http.patch(this.endPointUrl + "user/v1/"+id,body)
  }

  public resetPassword(body:{}) {
    return this.http.post(this.endPointUrl + `user/v1/reset/password`,body);
  }

  public changePassword(body:{}) {
    return this.http.put(this.endPointUrl + `user/v1/password/change`,body);
  }

  public resendLink(params: any) {
    return this.http.put(this.endPointUrl + `user/v1/password/forgot/${params.email}`, { "email": params.email });
  }
    //edited
    public loginFun(body:any){
      return this.http.post(this.endPointUrl+"token",body)
    }

}

export interface UserDetails {
  id: string,
  firstName?: string,
  lastName?: any,
  email?: string,
  phoneNumber:number,
  organisationName?:string,
}





